'use strict';

const countryCheck = require('../changeCountry/countryCheck');
const accessibility = require('../util/accessibility');

/**
 * Sets up the consent change listener for OneTrust.
 */
function setupConsentChangeListener() {
    if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
        window.OneTrust.OnConsentChanged(function () {
            countryCheck.geoCountryOverlayCheck();
        });
    }
}

/**
 * Waits for the OneTrust cookie banner to be added to the DOM,
 * sets focus to the policy text for screen reader accessibility,
 * and binds consent change events.
 *
 * @function
 * @returns {void}
 */
function waitForOneTrustBannerAndFocus() {
    const maxWait = 5000; // Timeout after 5 seconds
    let observerDisconnected = false;
    let observer = null;
    const disconnectObserver = () => {
        if (!observerDisconnected) {
            observer.disconnect();
            observerDisconnected = true;
        }
    };
    observer = new MutationObserver(() => {
        const $banner = $('#onetrust-banner-sdk');
        const $policyText = $('#onetrust-policy-text');
        const oneTrust = window.OneTrust;

        if ($banner.length && $policyText.length && oneTrust) {
            disconnectObserver();
            $policyText.attr('tabindex', '0').focus();
            setupConsentChangeListener();
        }
    });

    // Start observing DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Fallback to stop observing after timeout
    setTimeout(() => {
        if (!observerDisconnected) {
            countryCheck.geoCountryOverlayCheck();
        }
        disconnectObserver();
    }, maxWait);
}

/**
 * Handles actions when the 'change-country-modal' is closed/shown.
 * This function listens for the 'hidden.bs.modal' and 'shown.bs.modal' event and performs actions when the modal is hidden and shown.
 * @function
 * @returns {void}
 */
function handleChangeCountryModalClose() {
    $('#change-country-modal').on('hidden.bs.modal', function () {
        $(this).off('keydown.trapFocus');
        var $popup = $('#discount-popup-nb-reward-container, #discount-popup-container').filter(':visible');
        if ($popup.length) {
            accessibility.modalTrapFocus($popup);
        }
    });

    $('#change-country-modal').on('shown.bs.modal', function () {
        accessibility.modalTrapFocus($(this));
    });
}

module.exports = {
    waitForOneTrustBannerAndFocus: waitForOneTrustBannerAndFocus,
    handleChangeCountryModalClose: handleChangeCountryModalClose
};
